import React from "react";
import moment from "moment";

class TableDailyStatsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stats: [],
    };
  }

  getGrowing(stats) {
    const ordered = stats.slice().reverse();
    if (!ordered.length) return ordered;
    const growing = ordered.map((stat, i) => {
      if (i === ordered.length - 1) return stat;
      return Object.assign(stat, {
        growing: parseFloat((stat.value - ordered[i + 1].value).toFixed(1)),
        meta: moment(stat.meta).format("MMM DD, YYYY"),
      });
    });
    return growing;
  }

  componentDidMount() {
    this.setState({
      stats: this.getGrowing(this.props.stats),
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stats !== this.props.stats) {
      this.setState({
        stats: this.getGrowing(this.props.stats),
      });
    }
  }

  render() {
    const { unitSelected = "cm" } = this.props;
    const { stats } = this.state;
    return (
      <section role="table-wrapper">
        <table role="report-table">
          <thead role="table-header">
            <tr>
              <th>Date</th>
              <th>{unitSelected.toUpperCase()}</th>
              <th>Change</th>
            </tr>
          </thead>
          <tbody role="table-body">
            {stats.map((stat) => {
              const { meta, value, growing = "-" } = stat;
              const date = moment(meta).format("MMM D, YYYY");
              return (
                <tr key={`${stat.value}${stat.meta}`}>
                  <td>{date}</td>
                  <td className="measure">{value}</td>
                  <td className="growing">
                    {growing !== "-"
                      ? [
                          <img
                            src={`/img/new-icons/arrow-${
                              growing > 0 ? "up-blue" : "down-green"
                            }.svg`}
                          />,
                          <span>
                            {growing > 0 ? `+${growing}` : growing}
                            {` ${unitSelected}`}
                          </span>,
                        ]
                      : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    );
  }
}

export default TableDailyStatsComponent;
